import React from 'react';
import { Scrollup } from 'Ui';

const App = () => {
  return <Scrollup />;
};

export default App;
